import { Deserializable } from '../../protocols/deserializable';

export class SignInRequest implements Deserializable {
  constructor(public email: string = '', public password: string = '') {}

  onDeserialize = () => {};
}
